import {
  NCCard as NCCardPrimitive,
  NCCard2SectionLayout as NCCard2SectionLayoutPrimitive,
  NCCard2SectionLayoutProps,
  NCCardHeader as NCCardHeaderPrimitive,
  NCCardHeaderProps,
  NCCardProps,
  NCCardSectionHeader as NCCardSectionHeaderPrimitive,
  NCCardSectionHeaderProps,
} from '@/components/NCCard/NCCard';

export const NCCard = ({ children, ...props }: NCCardProps) => {
  return <NCCardPrimitive {...props}>{children}</NCCardPrimitive>;
};

export const NCCardHeader = ({ children, ...props }: NCCardHeaderProps) => {
  return <NCCardHeaderPrimitive {...props}>{children}</NCCardHeaderPrimitive>;
};

export const NCCard2SectionLayout = ({ children, ...props }: NCCard2SectionLayoutProps) => {
  return <NCCard2SectionLayoutPrimitive {...props}>{children}</NCCard2SectionLayoutPrimitive>;
};

export const NCCardSectionHeader = ({ ...props }: NCCardSectionHeaderProps) => {
  return <NCCardSectionHeaderPrimitive {...props} />;
};
